import React from 'react';

import { TextField, InputAdornment, makeStyles } from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import action_library_messages from 'messages/action_library_messages';

const useStyles = makeStyles(theme => ({
  searchField: {
    marginBottom: theme.spacing(2),
  },
}));

interface AssetSearchFieldProps {
  search: string;
  onSearchChange: (value: string) => void;
}

const AssetSearchField: React.FC<AssetSearchFieldProps> = ({ search, onSearchChange }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <TextField
      className={classes.searchField}
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      onChange={e => onSearchChange(e.target.value)}
      placeholder={t(action_library_messages.instance.asset_selection.search_placeholder)}
      value={search}
      variant='outlined'
    />
  );
};

export default AssetSearchField;
